/**
 * TMS-8318 — placas do modal de expedição, filtradas pelo cadastro escolhido
 * (partiprod_id), não pelo enum tp_rodado.
 *
 * Cavalo abre secundário (carreta, semi-reboque, vanderleia, rodotrem) e
 * terciário (cadastro cujo nome é Carreta ou "Carreta" + complemento).
 */

const SITUACOES_OPENTECH = [2, 7, 11, 12];

const REBOQUES_SECUNDARIOS = [
  "carreta",
  "semi reboque",
  "semirreboque",
  "vanderleia",
  "rodotrem",
];

const REBOQUES_TERCIARIOS = ["carreta"];

export function normalizaTipo(label) {
  return String(label || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

function descricaoCasaCom(label, raizes) {
  const nome = normalizaTipo(label);
  if (!nome) {
    return false;
  }

  const compacto = nome.replace(/[^a-z]/g, "");

  return raizes.some((raiz) => {
    const raizCompacta = raiz.replace(/[^a-z]/g, "");

    return (
      nome === raiz ||
      nome.startsWith(`${raiz} `) ||
      (raizCompacta !== "" && compacto.startsWith(raizCompacta))
    );
  });
}

export function ehCarreta(label) {
  return descricaoCasaCom(label, REBOQUES_SECUNDARIOS);
}

export function ehReboqueTerciario(label) {
  return descricaoCasaCom(label, REBOQUES_TERCIARIOS);
}

export function idsPorPapel(options, papel) {
  const combina = papel === "terciario" ? ehReboqueTerciario : ehCarreta;

  return (options || [])
    .filter((option) => combina(option.label))
    .map((option) => Number(option.value));
}

function opentechVigente(item, now) {
  const situacao = item && item.ultima_situacao;
  if (!situacao) {
    return false;
  }

  const recomendado = SITUACOES_OPENTECH.includes(Number(situacao.tp_situacao));
  const expira = new Date(situacao.dt_expiracao);

  return recomendado && expira >= now;
}

/**
 * @returns {{ options: Array, descartados: number }}
 */
export function placasDoTipo(vehicles, { transportadoraId, partiprodIds, validaOpentech, now = new Date() }) {
  const permitidos = new Set((partiprodIds || []).map((id) => Number(id)));
  const options = [];
  let descartados = 0;

  (vehicles || []).forEach((item) => {
    if (Number(item.pessoa_id_agenciador) !== Number(transportadoraId)) {
      descartados += 1;
      return;
    }

    if (!permitidos.has(Number(item.partiprod_id))) {
      return;
    }

    if (Number(validaOpentech) === 1 && !opentechVigente(item, now)) {
      return;
    }

    options.push({
      label: item.label,
      value: item.meiotransp_id,
      tp_rodado: item.tp_rodado,
      partiprod_id: item.partiprod_id,
      veiculo_id: item.veiculo_id,
      ultima_situacao: item.ultima_situacao,
    });
  });

  return { options, descartados };
}
